/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import ProgramStep from "@shared/Program/ProgramStep/ProgramStep";
import DocSignDocument from "@/core/modules/DocSign/data/DocSignDocument/DocSignDocument";
import {StepType} from "@shared/Program/ProgramStep/helpers/ProgramStepEnums";
import {Type} from "class-transformer";



export default class ContractProgramStep extends ProgramStep{

	//TODO completely remove contract property from here and lazy load when needed instead
	@Type(() => DocSignDocument)
	contract: DocSignDocument = null

	constructor(name: string = "", description: string = "", subStepList: ProgramStep[] = []) {
		super(name, description, subStepList, StepType.CONTRACT);
	}

}



